module.exports = __webpack_public_path__ + "img/only-midwindow.5db3950d.svg";